import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class AggLoader extends Loader {}

export const aggLoader = new AggLoader({
  service: SERVICES.agg
})
